import React from 'react';

const DotLine = props => {
  const className = props.PlanCard ? 'DotLinePlanCard' : 'DotLineWhite';
  const customClassName = props.className ? `${className} ${props.className}` : className; 
  return <div className={customClassName} style={{ width: '100%', ...props.style }} />;
};

export default DotLine;
